var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { Fragment } from "react";
import { Hint } from "react-bootstrap-typeahead";
import { Form } from "react-bootstrap";

import ClearButton from "./ClearButton";

var SelectSingleInput = function SelectSingleInput(_ref) {
  var inputRef = _ref.inputRef,
      referenceElementRef = _ref.referenceElementRef,
      size = _ref.size,
      shouldSelectHint = _ref.shouldSelectHint,
      selectedValue = _ref.selectedValue,
      clearButton = _ref.clearButton,
      onClickClear = _ref.onClickClear,
      readonly = _ref.readonly,
      onBlur = _ref.onBlur,
      required = _ref.required,
      inputProps = _objectWithoutProperties(_ref, ["inputRef", "referenceElementRef", "size", "shouldSelectHint", "selectedValue", "clearButton", "onClickClear", "readonly", "onBlur", "required"]);

  return React.createElement(
    Hint,
    { shouldSelect: shouldSelectHint },
    React.createElement(
      Fragment,
      null,
      React.createElement(Form.Control, _extends({
        autoComplete: "null"
      }, inputProps, {
        ref: function ref(node) {
          inputRef(node);
          referenceElementRef(node);
        },
        className: "custom-select " + (size ? "form-control-" + size : ""),
        readOnly: readonly,
        onBlur: onBlur,
        required: required
      })),
      clearButton && React.createElement(ClearButton, { onClick: onClickClear })
    )
  );
};

export default SelectSingleInput;